import { ChallengeFormType, FormValidator } from '../../NewChallengeForm.types';

export const validate: FormValidator<Pick<ChallengeFormType, 'labelIds'>> = ({
  labelIds,
}) => {
  if (!labelIds) return { isValid: false, message: '라벨을 확인해주세요' };
  return { isValid: true };
};
